import React from 'react'
import { useSelector } from 'react-redux'
import { addEditUrls } from 'services/api.enums'
import { addEditDataAPI } from 'services/CRUDServices'

function useAddSubZone() {
  const { CurrentHub } = useSelector((state: any) => state.currentHubInfo)
  async function handleAddSubZoneArea(data) {
    console.log("data is",data)
    const polyData = {
      selectHub: CurrentHub,
      countrydevision: {
        id: data?.id,
        text: data.name,
      },
      selectuser: {
        id: '444',
        text: '',
      },
      countrytype: data?.countrytype,
      polygon: `[[\n ${data.polygone
        .map(
        (item: any) => `\n ${JSON.stringify(item)}`
      )},\n],\n];`,
    }
    await addEditDataAPI(addEditUrls.createSubzone, 'post', polyData)
 
  }

  return { handleAddSubZoneArea }
}

export default useAddSubZone
